<template>
  <div class="container">
    <Carousel/>
     <hr class="featurette-divider">
        <div class="row featurette">
          <div class="col-md-5 order-md-2">
            <img class="featurette-image img-fluid mx-auto" src="../assets/img/pack.png" alt="Generic placeholder image">
          </div>
          <div class="col-md-7 order-md-1">
            <h2 class=" display-3">Refill and <span class="text-muted">Reuse</span></h2>
            <p class="lead pl-6 pl-">Out of Sanitizer in Wristband? No worries! Fill wristband with your hand sanitizer gel or liquid of choice. Press the top of the Sanitizer Wristband to release gel to hand anytime.</p>
          </div>
        </div>
        <hr class="featurette-divider">
        <div class="row justify-content-center" style="padding: 50px 0 40px 0">
        <div class="text-center">
          <div class="offer_content">
            <h1 class="text-uppercase mb-10 display-3">Shop Now</h1>
          </div>
        </div>
        </div>
  </div>
</template>
<script>
import Carousel from '@/components/Carousel'
export default {
  components: {
    Carousel
  },
  methods: {
    trackClick (e) {
      window.analytics.track('Visited Shop from Home Banner', {
        destination: e.target.innerText
      })
    },
    trackResellerIntent (e) {
      window.analytics.track('Visited Resell from Home Banner', {
        destination: e.target.innerText
      })
    }
  }
}
</script>
<style scoped>
.featurette-divider {
  margin: 5rem 0;
}

.featurette-heading {
  font-weight: 300;
  line-height: 1;
  letter-spacing: -0.05rem;
}

@media (min-width: 40em) {
  /* Bump up size of carousel content */
  .carousel-caption p {
    margin-bottom: 1.25rem;
    font-size: 1.25rem;
    line-height: 1.4;
  }

  .featurette-heading {
    font-size: 50px;
  }
  p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
}

@media (min-width: 62em) {
  .featurette-heading {
    margin-top: 7rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HomeBanner.vue